import React from "react";
import Avvvatars from "avvvatars-react";

interface TeacherSideBarProps {
  teacherData?: any;
}

const TeacherSidebar: React.FC<TeacherSideBarProps> = ({ teacherData }) => {
  return (
    <div className="col-xxl-3 col-xl-4 theiaStickySidebar">
      <div className="stickytopbar pb-4">
        <div className="card border-white">
          <div className="card-header">
            <div className="d-flex align-items-center flex-wrap row-gap-3">
              <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                {teacherData?.avatar?.temporaryUrl ? (
                  <img
                    src={teacherData?.avatar?.temporaryUrl}
                    alt={`${teacherData?.lastname} ${teacherData?.firstname}`}
                  />
                ) : (
                  <Avvvatars
                    value={`${teacherData.firstname?.charAt(0) || ""}${
                      teacherData.lastname?.charAt(0) || ""
                    }`}
                    style="character" // ou "character"
                    size={70}
                  />
                )}
              </div>
              <div>
                {teacherData?.statut ? (
                  <span className="badge badge-soft-success d-inline-flex align-items-center mb-1">
                    <i className="ti ti-circle-filled fs-5 me-1" />
                    Active
                  </span>
                ) : (
                  <span className="badge badge-soft-danger d-inline-flex align-items-center mb-1">
                    <i className="ti ti-circle-filled fs-5 me-1" />
                    Inactive
                  </span>
                )}
                <h5 className="mb-1 mb-1 text-truncate">{`${teacherData?.firstname} ${teacherData?.lastname}`}</h5>
                {/* <p className="text-primary mb-1">T849126</p> */}
                <p>
                  {teacherData?.birthday
                    ? new Date(teacherData.birthday).toLocaleDateString(
                        "en-GB",
                        {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        },
                      )
                    : "- -"}
                </p>
              </div>
            </div>
          </div>
          {/* Basic Information */}
          <div className="card-body">
            <h5 className="mb-3">Information de base</h5>
            <dl className="row mb-0">
              <dt className="col-6 fw-medium text-dark mb-3">Specialité</dt>
              <dd className="col-6  mb-3">{teacherData?.speciality}</dd>
              <dt className="col-6 fw-medium text-dark mb-3">Genre</dt>
              <dd className="col-6  mb-3">{teacherData?.sexe}</dd>
              <dt className="col-6 fw-medium text-dark mb-3">
                Date de Naissance
              </dt>
              <dd className="col-6  mb-3">
                {teacherData?.birthday
                  ? new Date(teacherData.birthday).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                  : "- -"}
              </dd>
            </dl>
          </div>
          {/* /Basic Information */}
        </div>
        <div className="card border-white">
          <div className="card-body">
            <h5 className="mb-3 ">Contact Principal Info</h5>
            <div className="d-flex align-items-center mb-3">
              <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                <i className="ti ti-phone" />
              </span>
              <div>
                <span className=" text-dark fw-medium mb-1">
                  Numéro téléphone
                </span>
                <p>{teacherData?.number}</p>
              </div>
            </div>
            <div className="d-flex align-items-center">
              <span className="avatar avatar-md bg-light-300 rounded me-2 flex-shrink-0 text-default">
                <i className="ti ti-mail" />
              </span>
              <div>
                <span className="text-dark fw-medium mb-1">Adresse mail</span>
                <p>{teacherData?.email}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherSidebar;
